export function convertStringToDate(dateString: string) {
  const [day, month, year] = dateString.split('/').map((str) => parseInt(str, 10));
  return new Date(year, month - 1, day);
}
